import {
  GOVGR_ERROR_MESSAGE,
  GOVGR_VISUALLY_HIDDEN,
} from "../../conf/styles/GovGrDate";
import getDateErrorText from "./getDateErrorText";

const Errors = ({
  isErrorAndTouched,
  error,

  invalidDateText,
}) => {
  return (
    <>
      <p className={`${GOVGR_ERROR_MESSAGE} mt-2`}>
        <span className={GOVGR_VISUALLY_HIDDEN}>Λάθος:</span>

        {isErrorAndTouched && getDateErrorText(error, invalidDateText)}
      </p>
    </>
  );
};

export default Errors;
